<ul class="buttons-container">
  <li *ngIf="showDownloadPdf">
    <button (click)="triggerDownload(type.PDF)" class="download-btn">
      <span>{{ 'general.downloadPdf' | translate }}</span>
    </button>
  </li>
  <li *ngIf="showDownloadExcel">
    <button
      romaProFeature
      [feature]="featureExcel"
      (clicked)="triggerDownload(type.EXCEL)"
      class="download-btn"
    >
      <span>{{ 'general.downloadExcel2' | translate }}</span>
    </button>
  </li>
  <li *ngIf="showDownloadOther">
    <button
      romaProFeature
      [feature]="featureOther"
      (clicked)="triggerDownload(type.OTHER)"
      class="download-btn"
    >
      <span>{{ downloadOtherText | translate }}</span>
    </button>
  </li>
  <br />
  <div class="footer-container">
    <div class="close-dialog">
      <img
        (click)="closeBottomSheet()"
        src="assets/icons/gl_close-black.svg"
        alt=""
      />
    </div>
  </div>
</ul>
